import './styles.css';

export default function ReviewSessionCompetitionFooter({
  backButtonText = 'Back',
  nextButtonText = 'Next',
  onBack,
  onNext
}) {
  return (
    <div className="onboarding-review-session-footer">
      {onBack && (
        <button className="button onboarding-back-button" onClick={onBack}>
          {backButtonText}
        </button>
      )}
      <button className="button onboarding-big-button" onClick={onNext}>
        {nextButtonText}
      </button>
    </div>
  )
};